import { render, staticRenderFns } from "./DynamicInputs.vue?vue&type=template&id=1b6c5caa&"
import script from "./DynamicInputs.vue?vue&type=script&lang=js&"
export * from "./DynamicInputs.vue?vue&type=script&lang=js&"
import style0 from "./DynamicInputs.vue?vue&type=style&index=0&id=1b6c5caa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports